import React, { useState, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import logo from '../../../assets/Images/logo.png';
import { FaUser } from 'react-icons/fa';
import { AuthContext } from '../../../App';
import logout from '../../API/logout';
import { useNavigate } from 'react-router-dom';


const Header = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();
  const { isLoggedIn, updateLoginStatus } = useContext(AuthContext);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  const handleLinkClick = (path) => {
    if (location.pathname !== path) {
      setIsMenuOpen(false);
      setIsDropdownOpen(false);
    }
  };

  const handleLogout = async () => {
    const result = await logout();
    if (result.success) {
      updateLoginStatus(false);
      setIsDropdownOpen(false);
      navigate('/'); // Redirect to home page
    } else {
      console.error('Logout failed:', result.message);
    }
  };

  const renderUserMenu = () => (
    <div className="user-menu">
      {isLoggedIn ? (
        <button onClick={toggleDropdown} className="user-menu-toggle">
          <FaUser />
        </button>
      ) : (
        <Link to="/login" onClick={() => handleLinkClick('/login')} className="login-link">
          Login
        </Link>
      )}
      {isLoggedIn && isDropdownOpen && (
        <ul className="user-dropdown">
          <li>
            <Link to="/dashboard" onClick={() => handleLinkClick('/dashboard')}>
              Dashboard
            </Link>
          </li>
          <li>
            <button onClick={handleLogout} className="logout-btn">
              Logout
            </button>
          </li>
        </ul>
      )}
    </div>
  );

  return (
    <header className={`header-area header-sticky ${isMenuOpen ? 'menu-open' : ''}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <nav className="main-nav">
              <Link to="/" className="logo" onClick={() => handleLinkClick('/')}>
                <img src={logo} alt="Chain App Dev" />
              </Link>
              <ul className={`nav ${isMenuOpen ? 'show' : ''}`}>
  {['Home', 'Maps'].map((item) => (
    <li key={item} className="scroll-to-section">
      <Link
        to={item === 'Home' ? '/' : `/${item}`}
        className={location.pathname === (item === 'Home' ? '/' : `/${item}`) ? 'active' : ''}
        onClick={() => handleLinkClick(item === 'Home' ? '/' : `/${item}`)}
      >
        {item}
      </Link>
    </li>
  ))}
  <li className="scroll-to-section">
    <a href="https://store.mychurchofchrist.com/" target="_blank" rel="noopener noreferrer">
      Shop
    </a>
  </li>
  {['About', 'Contact', 'Developing', 'Newsletter'].map((item) => (
    <li key={item} className="scroll-to-section">
      <Link
        to={`/${item}`}
        className={location.pathname === `/${item}` ? 'active' : ''}
        onClick={() => handleLinkClick(`/${item}`)}
      >
        {item}
      </Link>
    </li>
  ))}
  <li className="scroll-to-section mobile-user-menu">{renderUserMenu()}</li>
</ul>
              <div className="desktop-user-menu">{renderUserMenu()}</div>
              <div className={`menu-trigger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
                <span>Menu</span>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
